import { MealCountDto, ServingLineSummary } from '@/models';

export class MealCountCalcs {
  constructor(public mealCounts: MealCountDto) { }

  get availableCount(): number {
    return (
      (this.mealCounts.receivedMeals.mealCountReceived +
        this.mealCounts.receivedMeals.mealCountLeftoverPrevious)
    );
  }

  get totalCount(): number {
    let lineSummary = new ServingLineSummary(this.mealCounts.servingLines);
    return lineSummary.totalCount;
  }
  get totalCountWithWaste(): number {
    let lineSummary = new ServingLineSummary(this.mealCounts.servingLines);
    return lineSummary.totalCountWithWaste;
  }
  get newLeftovers(): number {
    const leftovers = this.availableCount - this.totalCountWithWaste;
    return Math.max(leftovers, 0);
  }
}
